import React from 'react'

import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import capitalize from 'lodash/capitalize'
import cx from 'classnames'

import Loading from '@piconetworks/pkg-loading'
import Boutton from '@piconetworks/pkg-boutton'
import Picon from '@piconetworks/pkg-picon'

import PopupWindow from 'components/PopupWindow'
import AccountModule from 'modules/account'
import IntegrationsModule from 'modules/integrations'

import UninstallConfirmation from '../Generic.Uninstall'
import { loginResponse, getPopupUrl } from '../utils/appFunctions'
import getAppStoreIcon from 'utils/icons/appStoreIcons'
import usePopup from 'hooks/usePopup'
import styles from './IntegrationPurchaser.module.scss'

// Component for installing and uninstalling external apps like Stripe
const IntegrationInstallerDev = ({
    app = {
        label: '',
        name: '',
    },
    connectedExternalAccount = {
        id: '',
        type: '',
    },
}) => {
    const publisherId = useSelector(AccountModule.selectors.getPublisherId)
    const stripeExpressLoading = useSelector(IntegrationsModule.selectors.getStripeExpressConfigLoading)
    const [showInstallCTA, setShowInstallCTA] = useState(true)
    const [showUninstallCTA, setShowUninstallCTA] = useState(false)
    const [openPopup, setOpenPopup] = useState(false)
    const { setModalOpen, Popup } = usePopup()

    const closeModal = useCallback(() => {
        setModalOpen(false)
    }, [setModalOpen])

    const hasAppInstalled = !!connectedExternalAccount?.id
    const isStripe = app?.name === 'Stripe'
    const isStripeExpress = app?.label === 'stripe-express'

    useEffect(() => {
        if (hasAppInstalled) {
            setShowInstallCTA(false)
            setShowUninstallCTA(true)
        } else {
            setShowInstallCTA(true)
            setShowUninstallCTA(false)
        }
    }, [hasAppInstalled])

    const dispatch = useDispatch()
    const appName = capitalize(connectedExternalAccount?.type)

    const disconnectAccount = useCallback(() => {
        dispatch(IntegrationsModule.creators.openUninstallModal({ appName }))
    }, [dispatch])


    return (
        <div className={styles.purchaseAction}>
            {(isStripe || isStripeExpress) && <Popup onAfterClose={() => {
                return closeModal()
            }}>
                <div className={styles.container}>
                    {stripeExpressLoading ? <Loading /> : 
                    <>
                        <div className={styles.header}>
                            <button
                                type="button"
                                className={styles.cancel}
                                onClick={() => closeModal()}
                            >
                                <span className={'icon-icon_close'} />
                            </button>
                        </div>
                        <div className={styles.express}>
                            <div className={styles.headerIcon}>
                                {getAppStoreIcon('payments')}
                            </div>
                            <h1>Open for business.</h1>
                            <p>
                                Connect your personal bank account to Hype to start collecting tips, offering memberships, and more.
                            </p>
                            <Boutton
                                onClick={(e) => {
                                    dispatch(IntegrationsModule.creators.startStripeExpress())
                                    // closeModal()
                                    // setOpenPopup(true)
                                }}
                                className={styles.button}
                                icon={
                                    <span
                                        className={cx(
                                            'icon-icon_bank',
                                            styles.icon,
                                            styles.button
                                        )}
                                    />
                                }
                                variant="secondary"
                            >
                                Connect personal bank account
                            </Boutton>
                            <div className={styles.poweredBy}>Powered by <a href="https://stripe.com/" target="_blank"><Picon icon='stripe' /></a></div>
                        </div>
                        <div className={styles.standard}>
                            <h2>Do you have a registered business?</h2>
                            <p>
                                Connect your own Stripe account to Hype for more insights and full access to transaction data.
                                Recurring revenue may be subject to <a href="https://stripe.com/billing/pricing/" target="_blank">additional fees</a> from Stripe.
                            </p>
                            <Boutton
                                onClick={(e) => {
                                    closeModal()
                                    setOpenPopup(true)
                                }}
                                className={styles.button}
                                icon={
                                    <span
                                        className={cx(
                                            'icon-app-stripe',
                                            styles.stripeIcon
                                        )}
                                    >
                                        <span className="path1" />
                                        <span className="path2" />
                                    </span>
                                }
                                variant="secondary"
                            >
                                Connect Stripe account
                            </Boutton>
                        </div>
                    </>}
                </div>
            </Popup>}

            {openPopup && (
                <PopupWindow
                    handleResponse={loginResponse({ dispatch, type: app?.label })}
                    onClose={() => setOpenPopup(false)}
                    title={`${app?.name} Integration`}
                    url={getPopupUrl(app?.label, publisherId, false)}
                />
            )}

            {showInstallCTA && (
                <Boutton onClick={() => {isStripe || isStripeExpress ? setModalOpen(true) : setOpenPopup(true)}} variant="primary">Install</Boutton>
            )}

            {showUninstallCTA && (
                <div className={styles.appUninstall}>
                    <Boutton
                        className={cx(styles.dangerButton)}
                        icon={<Picon icon="minus" color="#FFFFFF" />}
                        onClick={disconnectAccount}
                        variant="danger"
                    >
                        Uninstall
                    </Boutton>
                    <UninstallConfirmation
                        id={connectedExternalAccount?.id}
                        actionKey={`uninstall${appName}`}
                        appName={connectedExternalAccount?.type}
                        closeOnSuccess={`${connectedExternalAccount?.type}Modal`}
                        name={app?.name}
                        espType={connectedExternalAccount?.type}
                    />
                </div>
            )}
        </div>
    )
}

export default IntegrationInstallerDev